/* JMT sections: product carousels, best-seller tabs (lazy panels) and hero slides. No dependencies. */
(() => {
  'use strict';

  const jmt = (window.jmt = window.jmt || {});
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Carousel: arrows enable and disable with scroll position ---------- */
  const initCarousel = (carousel) => {
    if (carousel.dataset.ready) return;
    carousel.dataset.ready = 'true';
    const track = $('[data-jmt-track]', carousel);
    const prev = $('[data-jmt-prev]', carousel);
    const next = $('[data-jmt-next]', carousel);
    if (!track) return;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      carousel.classList.toggle('has-overflow', max > 2);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    };
    const scrollBy = (direction) => track.scrollBy({ left: direction * track.clientWidth * 0.9, behavior: reduceMotion() ? 'auto' : 'smooth' });
    if (prev) prev.addEventListener('click', () => scrollBy(-1));
    if (next) next.addEventListener('click', () => scrollBy(1));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    update();
  };
  jmt.initCarousels = (root = document) => $$('[data-jmt-carousel]', root).forEach(initCarousel);
  jmt.initCarousels();

  /* ---------- Tabs: inactive panels are <template>s and are cloned in on first use ---------- */
  $$('[data-jmt-tabs]').forEach((section) => {
    const tabs = $$('[data-jmt-tab]', section);
    const cta = $('[data-jmt-tabs-cta]', section);

    const activate = (tab, focus) => {
      tabs.forEach((other) => {
        const on = other === tab;
        other.setAttribute('aria-selected', String(on));
        other.tabIndex = on ? 0 : -1;
        const panel = $(`[data-jmt-panel="${other.dataset.jmtTab}"]`, section);
        if (panel) panel.hidden = !on;
      });
      const panel = $(`[data-jmt-panel="${tab.dataset.jmtTab}"]`, section);
      const template = panel && $('[data-jmt-panel-template]', panel);
      if (template) {
        panel.append(template.content.cloneNode(true));
        template.remove();
        jmt.initCarousels(panel);
        if (jmt.wishlist) jmt.wishlist.render(panel);
      }
      if (cta) {
        cta.textContent = tab.dataset.ctaLabel;
        cta.href = tab.dataset.ctaHref;
      }
      if (focus) tab.focus();
      if (panel) requestAnimationFrame(() => jmt.initCarousels(panel));
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab, false));
      tab.addEventListener('keydown', (event) => {
        const keys = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: tabs.length - 1 };
        if (!(event.key in keys)) return;
        event.preventDefault();
        activate(tabs[(keys[event.key] + tabs.length) % tabs.length], true);
      });
    });
  });

  /* ---------- Hero: dots, optional autoplay ---------- */
  $$('[data-jmt-hero]').forEach((hero) => {
    const track = $('[data-jmt-track]', hero);
    const slides = $$('.jmt-hero__slide', hero);
    const dots = $$('[data-jmt-dot]', hero);
    if (!track || slides.length < 2) return;
    let index = 0;
    const show = (i) => {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: reduceMotion() ? 'auto' : 'smooth' });
    };
    dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.jmtDot))));
    track.addEventListener(
      'scroll',
      () => {
        const current = Math.round(track.scrollLeft / track.clientWidth);
        if (current === index) return;
        index = current;
        dots.forEach((dot, i) => (i === current ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current')));
      },
      { passive: true }
    );
    if (hero.dataset.autoplay === 'true' && !reduceMotion()) {
      let paused = false;
      setInterval(() => {
        if (!paused && !document.hidden) show(index + 1);
      }, (Number(hero.dataset.speed) || 6) * 1000);
      ['mouseenter', 'focusin', 'touchstart'].forEach((name) => hero.addEventListener(name, () => (paused = true), { passive: true }));
    }
  });
})();
